import {Component, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef} from '@angular/core';
import {DatacenterV2} from "@core/model/datacenter-v2";

@Component({
  selector: 'app-cluster-info-popup',
  styleUrl: './info-popup.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: false,
  template: `
    <div class="marker-popup-content">
      <span class="popup-tittle">{{item.provider}}</span>
      <hr>
      <span><b>MW Live</b> - {{item.mwLive | number:'1.0':'en-US'}}</span><br/>
      <span><b>MW U/C</b> - {{item.mwUC | number:'1.0':'en-US'}}</span><br/>
      <span><b>MW Planned</b> - {{item.mwPlanned | number:'1.0':'en-US'}}</span><br/>
    </div>
  `
})
export class ClusterInfoPopupComponent {
  private _item: DatacenterV2 = null;

  get item(): DatacenterV2 {
    return this._item;
  }

  set item(value: DatacenterV2) {
    this._item = value;
    if (this.cdr) {
      this.cdr.detectChanges();
    }
  }

  constructor(private cdr: ChangeDetectorRef) {
  }
}
